<app-scrollable-dialog headerKey="button.selectReceivers">
  <ng-container content>
    <app-receivers-select-content
      [tableConfig]="tableConfig"
      [allFilters]="data.allFilters"
      [residents]="data.allResidents"
      [vmToTableRows]="vmToTableRows"
      [defaultSelected]="defaultSelected"
      [phoneStatuses]="data.phoneStatuses"
      [previousFilters]="data.previousFilters"
    ></app-receivers-select-content>
  </ng-container>
  <ng-container actions>
    <button mat-stroked-button class="mat-primary" [mat-dialog-close]="false">{{ 'button.cancel' | loc }}</button>
    <button mat-raised-button class="mat-primary mat-elevation-z0" (click)="submit()">{{ 'button.save' | loc }}</button>
  </ng-container>
</app-scrollable-dialog>
